import React from 'react';
import { useNavigate } from 'react-router-dom';

const InvoiceHeaderNavigator = () => {
  const navigate = useNavigate();

  return (
    <div className='flex items-start px-2.5 gap-1.5 w-full text-text-placeholder typo-b14'>
      <span
        className='hover:underline cursor-pointer'
        onClick={() => navigate('/mypage?tab=My%20Profile')}
      >
        My Page
      </span>
      /
      <span
        className='hover:underline cursor-pointer'
        onClick={() => navigate('/mypage?tab=Payments')}
      >
        Payments
      </span>
      /
      <span
        className='hover:underline cursor-pointer'
        onClick={() => navigate('/mypage?tab=Payments')}
      >
        Payments history
      </span>
      /<span className='hover:underline cursor-pointer'>Invoice</span>
    </div>
  );
};

export default InvoiceHeaderNavigator;
